export class AlimentoPreparadoModel {
    nombre: string; 
    categoria: string; 
    marca: string; 
    porcion: string;
    unidad: string; 
    calorias: number; 
    carbohidratos: number;
    azucar: number;
    fibra: number;
    proteinas: number;
    grasaTotal: number;
    grasaSaturada: number;
    grasaMonoinsaturada: number;
    grasaPoliinsaturada: number;
    grasaTrans: number;
    colesterol: number;
    imagen?: {
        nombre: string;
        url: string;
    };
    informacion: string;
    propietario: string;
    activo: boolean; // bandera que sirve para aliminar elemento
    empresaId: string;
}

export const categoriasPreparados: string[] = [
    'Aderezos',
    'Otros preparados',
    'Salsas',
];
